import React from 'react'
import {convertDate, stringToHML, convertDateTime} from './generalfunctions.jsx'
import Akkord from './akkord.jsx'
import 'material-icons/iconfont/material-icons.css';
import YoutubeVideo from './youtubevideo.jsx';  
import Produkt from './produkt.jsx'

const Schueler = (props) => {    

    function unterrichtseinheitRow(ue){
    
        let videourl = null
        if (ue.videourl !== null && ue.videourl !==""){
            const ref=`https://www.youtube.com/watch?v=${ue.videourl}`
            videourl= <a href={ref} target="_blank"><img src="/assets/images/movie24.png" height="24" />&nbsp;Video...</a>           
        }
        let pdf = null
        if (ue.pdf_id !== 0){
            const ref=`/media/pdf/${ue.pdf_id}.pdf`
            pdf= <a href={ref} target="_blank"><img src="/assets/images/pdf24.png" height="24" />&nbsp;{ue.dateinamepdf}</a>          
        }
        let bemerkungen = null
        if (ue.bemerkungen !==null && ue.bemerkungen !==""){
            bemerkungen=<tr><td>{stringToHML(ue.bemerkungen)}</td></tr>
        }

        let btnsEdit = null
        let lbThema = stringToHML(ue.thema)

        let moveBtn = <button onClick={()=>props.moveUnterrichtseinheit(ue)}  className="btn-sm-round btn-danger"><i className="material-icons"> arrow_upward </i></button>
        if (ue.rangfolge===1) moveBtn = null;


        if (props.schuelerPage === 2){
            btnsEdit = <><button onClick={()=>props.editUnterrichtseinheit(ue)}   className="btn-sm-round btn-secondary"><i className="material-icons"> edit </i></button> <button className="btn-sm-round btn-info" onClick={()=>props.deleteUnterrichtseinheit(ue)}><i className="material-icons"> close </i></button>  {moveBtn}</>
            lbThema = stringToHML(ue.lernziele)
        }

        return (
            <>
                <table className="table">
                    <tbody>
                        <tr>
                            <td width={15} className="light-gray">{ue.rangfolge}</td>
                            <td>{lbThema}<br/>{videourl}&nbsp;&nbsp;&nbsp;{pdf} </td>
                            <td width={150}>{btnsEdit}</td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>


           
                <hr/>                  
            </>
        )
    }

    function lektionenRow(lektion){
    
            if (lektion === null || lektion === undefined) return null

            if (props.schuelerPage === 1 && lektion.ist_abgeschlossen===0){
                return null
            }

            if (lektion.hat_taegliche_uebungen==1) return null
    
            
    
            let unterrichtseinheiten =  lektion.unterrichtseinheiten.map(unterrichtseinheitRow)

            if (lektion.ist_abgeschlossen===0){
                unterrichtseinheiten =  props.getString('$STR_0222')
            }            
    
            return(
                <tr>
                    <td width={20}><b>{lektion.lfdnr}</b></td>
                    <td width={150}>{convertDateTime(lektion.unterrichtszeit)}</td>
                    <td>{unterrichtseinheiten}</td>   
                </tr>
            )
        }    

        let divAboBestaetigen = null
        if (props.angebotSchuelerAbo!==null && props.angebotSchuelerAbo.angenommen_am===null){
            divAboBestaetigen=<div style={{marginTop:'25px'}}><a className="btn btn-form btn-primary display-4" href="#" onClick={props.onShowAngebotAbo}>{props.getString('$STR_0186')}</a></div>
    }

    const buttonUnterrichtsanfrage=<a style={{marginBottom:'35px'}} className="btn btn-form btn-primary display-4" href="#" onClick={props.neueUnterrichtsanfrage}>{props.getString('$STR_0122')}</a>

    let lektionen = <b>{props.getString('$STR_0214')}</b>
    if (props.schueler_lektionen !== undefined && props.schueler_lektionen !== null && props.schueler_lektionen.length > 0){
        lektionen = <table className="table"><tbody>{props.schueler_lektionen.map(lektionenRow)}</tbody></table>
    }

    const buttonNeueTaeglicheLektion = (
       
        <div className="dropdown">
            <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {props.getString('$STR_0228')}
            </button>
            <ul className="dropdown-menu">
                <button  onClick={props.addTaeglicheUebung} className="dropdown-item" >{props.getString('$STR_0230')}</button>    
                <button  onClick={props.addTaeglicheUebungAusListe} className="dropdown-item" >{props.getString('$STR_0231')}</button>    
      
            </ul>
        </div>
    )

    let schueler_taeglicheLektion = <><b>{props.getString('$STR_0229')}</b>{buttonNeueTaeglicheLektion}</>
    if (props.schuelerTaeglicheLektion.unterrichtseinheiten.length >0){
        schueler_taeglicheLektion = (
            <div>
                {buttonNeueTaeglicheLektion}
                <table className="table"><tbody>{props.schuelerTaeglicheLektion.unterrichtseinheiten.map(unterrichtseinheitRow)}</tbody></table>
            </div>
        )
    }   

    let nav_seite1_className = "nav-link";
    let nav_seite2_className = "nav-link";
    let nav_seite3_className = "nav-link";
    let nav_seite4_className = "nav-link";
    let nav_seite5_className = "nav-link";
    let nav_seite6_className = "nav-link";
    if (props.schuelerPage===1) nav_seite1_className = "nav-link active";
    if (props.schuelerPage===2) nav_seite2_className = "nav-link active";
    if (props.schuelerPage===3) nav_seite3_className = "nav-link active";
    if (props.schuelerPage===4) nav_seite4_className = "nav-link active";
    if (props.schuelerPage===5) nav_seite5_className = "nav-link active";
    if (props.schuelerPage===6) nav_seite6_className = "nav-link active";

    let liAbo = null
   
    if (props.activeSchuelerAbo!== null){
            liAbo = (
                <li className="nav-item ">
                    <button onClick={()=>props.setSchuelerPage(3)} className={nav_seite3_className}>{props.getString('$STR_0201')}</button>
                </li>
            )
    }

    let nav = (
        <ul className="nav nav-pills">
            <li className="nav-item ">
                <button onClick={()=>props.setSchuelerPage(1)} className={nav_seite1_className}>{props.getString('$STR_0215')}</button>
            </li>
            <li className="nav-item ">
                <button onClick={()=>props.setSchuelerPage(6)} className={nav_seite6_className}>{props.getString('$STR_0255')}</button>
            </li>
            <li className="nav-item ">
                <button onClick={()=>props.setSchuelerPage(2)} className={nav_seite2_className}>{props.getString('$STR_0221')}</button>
            </li>
            <li className="nav-item ">
                <button onClick={()=>props.setSchuelerPage(5)} className={nav_seite5_className}>{props.getString('$STR_0223')}</button>
            </li>
            {liAbo}
            <li className="nav-item ">
                <button onClick={()=>props.setSchuelerPage(4)} className={nav_seite4_className}>{props.getString('$STR_0090')}</button>
            </li>
        </ul>
    )
    let aktuellesAbo = null
    let aktuelleLektionen = null
   
    if (props.activeSchuelerAbo !== null && props.schueler_lektionen !== undefined){
       aktuellesAbo = <div style={{marginTop:'25px'}}>{stringToHML(props.activeSchuelerAbo.angebot_html)}</div>
       aktuelleLektionen =<div style={{marginTop:'25px',padding:'15px', backgroundColor:'white', borderRadius:'10px'}}><table><tbody>{props.schueler_lektionen.map(lektionenRow)    }</tbody></table></div>
    }

    function akkordRow(benutzerakkord){
        return(
            <div className="col">
                <Akkord
                    akkord={benutzerakkord.akkord}
                    language={props.language}
                />
            </div>
        )
    }

    function produktRow(pl){

        if (props.gekauft(pl)){
            return (
                <Produkt
                    produkt={pl}
                    zeigeProdukt={props.zeigeProdukt}
                    gekauft={props.gekauft}
                    zeigePreis={false}  
                    root="schuelerKauf"    
                    inDenEinkaufswagen={props.inDenEinkaufswagen}             
                />
            )
        }
        return null
    }   

    const meineKaeufe=(
        <div className="text-center showin" style={{ marginTop:'15px', minHeight:'700px',padding:'25px',  overflowY:'auto', }}>
       
                <div className="row">                      
                    {props.produkt_lektionen.map(produktRow)}  
                </div>
        </div>
)
  

    const meinegitarrenakkorde =(
        <>
        <div style={{marginTop:'25px'}}>
            <center>
               <button className="btn btn-primary" style={{width:'400px'}}  onClick={props.setAkkordePage}>{props.getString('$STR_0226')}</button>
            
            </center>
        </div>
        <div className="row">
            {props.benutzer_akkorde.map(akkordRow)}
 
        </div>
        </>
    )   

    let content = null
    switch (props.schuelerPage){
        case 1:
            content = <div style={{padding:'35px'}}>{lektionen}</div>
            break;
        case 2:
            content =  <div style={{padding:'35px'}}>{schueler_taeglicheLektion}</div>  
            break
        case 3:
            content = (
                <>
                   
                   <div style={{ padding:'20px',}}><center>{aktuelleLektionen} {aktuellesAbo} {buttonUnterrichtsanfrage} </center></div>
                      
                </>
            )
            break
        case 4:
            content = props.accountContent
            break
        case 5:
            content = meinegitarrenakkorde
            break
        case 6:
            content = meineKaeufe
            break


    }
  
    return(

        <section className="cid-r8R4yMgBSy mbr-fullscreen mbr-parallax-background" id="header1-5" style={{backgroundImage: 'url(../../../assets/images/about7.png)'}}>    
            <div className="container" style={{marginTop:'55px'}}>
                <div className="row" style={{minHeight:'940px'}}>    
                    <div className="col slider-text  slider-text-two" style={{boxShadow: '3px 2px #232124, backgroundColor:white', textAlign:'left'}} >  
                    {nav}
                    {content}
                    </div>
                </div>
            </div>      
        </section>
        
       

    )


}

export default Schueler